import IconArrowLeft from '@apollo/icons/default/IconArrowLeft.svg';
import React from 'react';

type Props = {
  message: string;
};

const EmptySelectionPrompt = (props: Props) => (
  <div className="my-8 flex grow flex-col items-center justify-center text-placeholder">
    <div className="mb-4 flex size-10 items-center justify-center rounded-full border border-primary text-disabled">
      <IconArrowLeft />
    </div>
    <div className="max-w-xs px-10 text-center">{props.message}</div>
  </div>
);

export { EmptySelectionPrompt };
